import { Box, Container, Divider, Grid, Stack, Typography } from "@mui/material"
import locations from "../../locations"

function Footer() {
    return (
        <Box sx={{
            backgroundColor: "primary.main",
            p: 5
        }}>
            <Container maxWidth="lg">
                <Grid container spacing={2} sx={{
                    minHeight: "10rem",
                    width: "100"
                }}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="body2" gutterBottom sx={{
                            fontWeight: 700
                        }} color={"secondary"}>Mohlo by Vás zajímat</Typography>
                        <Typography variant="body1" color={"white"}>O nás</Typography>
                        <Typography variant="body1" color={"white"}>Kontakt</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} sx={{
                        textAlign: "center"
                    }}>
                         <img src="/logo512.png" alt="Logo" width={150} height={150}></img>
                    </Grid>
                    <Grid item xs={12} sm={4} textAlign={"right"}>
                        <Typography variant="body2" mb={2} gutterBottom sx={{
                            fontWeight: 700,
                        }} color={"secondary"}>Rychlý kontakt</Typography>
                        <Stack>
                            <Typography component="a" href='tel:+420777276064' variant="body1" color={"white"}>(+ 420) 777 276 064</Typography>
                            <Typography component="a" href='mailto: info@rsrent.cz' variant="body1" color={"white"}>info@rsrent.cz</Typography>
                        </Stack>
                    </Grid>

                </Grid>
                <Divider sx={{ my: 3 }}></Divider>
                <Box sx={{
                    textAlign: "center"
                }}>
                    <Typography variant="subtitle2" color={"grey"}>Působíme i v těchto městech</Typography>
                    <Typography variant="subtitle1" color={"white"}>{
                        locations.map(el => el.name).join(", ")
                    }</Typography>
                    <Typography variant="subtitle2" mt={2} color={"grey"}>2023 RSrent.cz</Typography>
                </Box>
            </Container>
        </Box>
    )
}

export default Footer